import { ObjectId } from "bson";

export enum RequestType {
    Quotation = "quotation",
    Consulting = "consulting",
    Help = "help & information",
    ThirdParty = "quilty subscription",
}

export enum RequestStatus {
    Open = "open",
    Closed = "closed",
    Accepted = "accepted",
    Denied = "denied",
    Processed = "processed",
    PaymentLinkSent = "payment link sent",
}

export enum PaymentPreferenceType {
    ACH = "ach",
    CREDIT_CARD = "credit card",
    INVOICE = "invoice",
    WIRE = "wire",
    OTHER = "unknown/other",
}

export interface Request {
    requestid: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    affiliatedOrganization: string;
    type: RequestType;
    title: string;
    description: string;
    status: RequestStatus;
    submissionDate: Date;
    userId?: ObjectId;
    paymentPreference?: PaymentPreferenceType;
    licenceCount?: number;
    requestReceiver?: "gse" | "quilty" | "both";
}

export type RawRequest = Pick<
    Request,
    | "requestid"
    | "firstName"
    | "lastName"
    | "phone"
    | "email"
    | "affiliatedOrganization"
    | "type"
    | "title"
    | "description"
    | "status"
    | "submissionDate"
    | "paymentPreference"
    | "licenceCount"
>;
